
import request from '@/config'
import { DicGroupListSearch, DicGroupBase } from './dto';

enum Apis {
    DeleteGroup = '/api/dictionarygroup/deletedicgroupbyid',
    GroupList = '/api/dictionarygroup/getpagedlist',
    Creation = '/api/dictionarygroup/Createion',
    Editor = '/api/dictionarygroup/Modify',
    Detail = '/api/dictionarygroup/GetDetail',
    DicMaps = '/api/dictionarygroup/GetDicMaps',
}

/* 获取分组数据列表 */
export const GetDicGroupListApi = (search: DicGroupListSearch): Promise<IResponse> => {

    return request.post({ url: Apis.GroupList, data: search })

}

export const CreateDicGroupApi = (inputs: DicGroupBase): Promise<IResponse> => {

    return request.post({ url: Apis.Creation, data: inputs })

}

export const ModifyDicGroupApi = (inputs: DicGroupBase): Promise<IResponse> => {

    return request.post({ url: Apis.Editor, data: inputs })

}

export const DeleteDicGroupApi = (search: DicGroupListSearch): Promise<IResponse> => {

    return request.post({ url: Apis.DeleteGroup, data: search })

}

export const GetGroupDetailAPi = (rowId: string): Promise<IResponse> => {

    return request.post({ url: Apis.Detail, data: { id: rowId } })

}

export const GetDictionaryMapApi = (): Promise<IResponse> => {

    return request.post({ url: Apis.DicMaps, data: {} })

}